import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------

export const navData = [
  /**
   * Overview
   */
  {
    subheader: 'Management',
    items: [
      {
        title: 'Dashboard',
        path: paths.dashboard.root,
        icon: <Iconify icon="solar:cpu-bold-duotone" />,
      },
      {
        title: 'IAM',
        path: paths.dashboard.iam.root,
        icon: ICONS.user,
      },
      {
        title: 'Locations',
        path: paths.dashboard.locations.root,
        icon: <Iconify icon="solar:map-point-wave-bold-duotone" />,
      },
      {
        title: 'Sync Account',
        path: paths.dashboard.syncAccount.root,
        icon: <Iconify icon="solar:transfer-horizontal-bold-duotone" />,
      },
    ],
  },
  {
    subheader: 'Ecommerce',
    items: [
      {
        title: 'Products',
        path: paths.dashboard.products.root,
        icon: <Iconify icon="solar:cup-hot-bold-duotone" />,
        dataTestId: 'nav-products',
      },
      {
        title: 'Modifiers',
        path: paths.dashboard.modifiers.root,
        icon: ICONS.parameter,
        dataTestId: 'nav-modifiers',
      },
      {
        title: 'Categories',
        path: paths.dashboard.categories.root,
        icon: ICONS.menuItem,
        dataTestId: 'nav-categories',
        children: [
          {
            title: 'Manage main categories',
            path: paths.dashboard.categories.root,
            dataTestId: 'nav-categories-main',
          },
          {
            title: 'Manage sub categories',
            path: paths.dashboard.categories.subCategories,
            dataTestId: 'nav-categories-sub',
          },
        ],
      },
      {
        title: 'Customers',
        path: paths.dashboard.customers.root,
        icon: <Iconify icon="solar:cart-4-bold-duotone" />,
      },
      {
        title: 'Orders',
        path: paths.dashboard.orders.root,
        icon: ICONS.ecommerce,
      },
    ],
  },
  {
    subheader: 'Promotions',
    items: [
      {
        title: 'eGift Cards',
        path: paths.dashboard.balanceTransfers.root,
        icon: <Iconify icon="solar:transfer-horizontal-bold-duotone" />,
        dataTestId: 'nav-balance-transfers',
      },
      {
        title: 'Events',
        path: paths.dashboard.events.root,
        icon: <Iconify icon="solar:clipboard-heart-bold-duotone" />,
        dataTestId: 'nav-events',
      },
    ],
  },
  {
    subheader: 'App settings',
    items: [
      {
        title: 'Notifications',
        path: paths.dashboard.notifications.root,
        icon: <Iconify icon="solar:bell-bold-duotone" />,
      },
      {
        title: 'App settings',
        path: paths.dashboard.appSettings.root,
        icon: <Iconify icon="solar:settings-bold-duotone" />,
        children: [
          {
            title: 'Product Settings',
            path: paths.dashboard.appSettings.productSettings,
            dataTestId: 'nav-product-settings',
          },
        ],
      },
    ],
  },
];
